"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var SurveyReact = _interopRequireWildcard(require("survey-react-ui"));
var _lodash = require("lodash");
var _surveyCore = require("survey-core");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Checking element has satisfied conditions or not
 * 1. Element is question
 * 2. Element is visible
 *
 * @param {Object} element    A object data
 * @return {Boolean}          Return boolean type after checked.
 */
var checkElementIsQuestionAndVisible = function checkElementIsQuestionAndVisible(element) {
  return (0, _lodash.get)(element, 'isQuestion') && (0, _lodash.get)(element, 'isVisible');
};
var HeaderSurvey = function HeaderSurvey(props) {
  var survey = props.survey,
    creator = props.creator,
    css = props.css,
    questions = props.questions,
    needClearErrorsWhenAllQuestionIsEmpty = props.needClearErrorsWhenAllQuestionIsEmpty;
  var _React$useState = _react.default.useState([]),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    rowsChildren = _React$useState2[0],
    setRowChildren = _React$useState2[1];
  var _React$useState3 = _react.default.useState([]),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    rows = _React$useState4[0],
    setRows = _React$useState4[1];
  var _React$useState5 = _react.default.useState(false),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    isExistVisibleRow = _React$useState6[0],
    setExistVisibleRow = _React$useState6[1];
  var _React$useState7 = _react.default.useState(null),
    _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
    headerRow = _React$useState8[0],
    setHeaderRow = _React$useState8[1];
  var _React$useState9 = _react.default.useState(true),
    _React$useState10 = (0, _slicedToArray2.default)(_React$useState9, 2),
    isHeaderVisible = _React$useState10[0],
    setHeaderVisible = _React$useState10[1];
  var createRow = function createRow(row) {
    return /*#__PURE__*/_react.default.createElement(SurveyReact.SurveyRow, {
      key: row.id,
      row: row,
      survey: survey,
      creator: creator,
      css: css
    });
  };
  var renderRows = function renderRows(questionRows) {
    var rows1 = [];
    for (var i = 0; i < questionRows.length; i += 1) {
      var visible = (0, _lodash.get)(questionRows[i], 'visible', false);
      rows1.push(createRow(questionRows[i]));
      if (!isExistVisibleRow && visible) {
        setExistVisibleRow(visible);
      }
    }
    return rows1;
  };

  /**
   * Clear errors when questions are wrapped by Header Survey Component
   * and in that form, all question has empty value.
   *
   * @param {Array} rowsChild   Rows children data.
   */
  var clearErrors = function clearErrors(rowsChild) {
    if ((0, _lodash.isEmpty)(survey.data) || (0, _lodash.values)(survey.data).every(_lodash.isNil)) {
      rowsChild.forEach(function (row) {
        var elements = (0, _lodash.get)(row, 'elements', []);
        elements.forEach(function (element) {
          if (element instanceof _surveyCore.PanelModel) {
            var subElements = (0, _lodash.get)(element, 'elements', []);
            subElements.forEach(function (subElement) {
              if (checkElementIsQuestionAndVisible(subElement)) {
                subElement.clearErrors();
              }
            });
          } else if (checkElementIsQuestionAndVisible(element)) {
            element.clearErrors();
          }
        });
      });
    }
  };
  (0, _react.useEffect)(function () {
    var dataSize = questions.length;
    if (dataSize > 0) {
      var question = questions[0];
      setHeaderRow(createRow(question));
      // Initialize visible status of header at the first time it is rendered
      setHeaderVisible((0, _lodash.get)(question, 'visibleElements.length') > 0);
      question.onPropertyChanged.add(function (internalQuestion) {
        // Update visible status of header when its visibleIf dependencies change value
        setHeaderVisible((0, _lodash.get)(internalQuestion, 'visibleElements.length') > 0);
      });
    }
    if (dataSize > 1) {
      setRowChildren(questions.slice(1));
    }
  }, [questions]);
  (0, _react.useEffect)(function () {
    if (rowsChildren.length > 0) {
      if (needClearErrorsWhenAllQuestionIsEmpty) {
        clearErrors(rowsChildren);
      }
      setRows(renderRows(rowsChildren));
    }
  }, [rowsChildren]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "header-row ".concat(isHeaderVisible ? 'header-visible' : '')
  }, " ", headerRow, /*#__PURE__*/_react.default.createElement("div", {
    className: "header-children-row ".concat(isExistVisibleRow ? '' : 'hide-row')
  }, rows));
};
HeaderSurvey.propTypes = {
  questions: _propTypes.default.instanceOf(Array).isRequired,
  survey: _propTypes.default.shape({
    data: _propTypes.default.shape({})
  }).isRequired,
  creator: _propTypes.default.shape({}).isRequired,
  css: _propTypes.default.shape({}).isRequired,
  needClearErrorsWhenAllQuestionIsEmpty: _propTypes.default.bool
};
HeaderSurvey.defaultProps = {
  needClearErrorsWhenAllQuestionIsEmpty: false
};
var _default = HeaderSurvey;
exports.default = _default;